<script setup>
const error = useError();
</script>
<template>
  <UApp :toaster="{ position: 'top-right' }">
    <NuxtLayout>
      <UContainer>
        <div class="prose">
          <TextHeading tag="h2">Error {{ error.statusCode }}</TextHeading>
          <p>
            <strong class="text-primary-500 primary">{{ error.message }}</strong>
          </p>
          <p>{{ $t('error.somethingBroke') }}</p>
          <p>{{ $t('error.sorry') }}</p>
        </div>
      </UContainer>
    </NuxtLayout>
  </UApp>
</template>
